import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsPurchasePointsEventRunning, selectPurchasePointEventRemainingTime, } from "../../../selectors/selectPurchasePointsEventInfo";
import { utilButton } from "../../../utils/utilButton";
import { utilTime } from "../../../utils/utilTime";
import { TimerCountdown } from "../../generic/timer/TimerCountdown";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
var _HudButtonPurchasePointsEvent = function (_a) {
    var onClick = _a.onClick, purchasePointsRemainingTime = _a.purchasePointsRemainingTime, shouldRender = _a.shouldRender;
    if (utilTime.secondsLeftTill(purchasePointsRemainingTime) <= 0 || !shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.TraderBadge + "  hud-button__offers hud-button__purchase-points-event", onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement(TimerCountdown, { remainingTime: purchasePointsRemainingTime, className: IdStyles.TextBoldPrimary + " hud-button__purchase-points-event-text" })));
};
var mapState = function (state) { return ({
    purchasePointsRemainingTime: selectPurchasePointEventRemainingTime(state),
    shouldRender: selectIsPurchasePointsEventRunning(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionModalOpen(IdModal.PurchasePointsEvent)); },
}); };
export var HudButtonPurchasePointsEvent = connect(mapState, mapDispatch)(_HudButtonPurchasePointsEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/components/HudButtonPurchasePointsEvent.tsx
// module id = 2295
// module chunks = 3